import { Box, Field, Input, InputProps } from "@chakra-ui/react";
import { get, useFormContext } from "react-hook-form";

interface InputFieldProps extends InputProps {
  name: string;
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  type?: "email" | "date" | "month" | "text" | "time" | "number";
}

export const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

function InputField({
  name,
  label = "",
  placeholder,
  isRequired = false,
  type = "text",
  ...props
}: InputFieldProps) {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);
  let watchedValue = watch(name); // Get current value from form state

  if (type == "date") {
    watchedValue = watchedValue ? formatDate(new Date(watchedValue)) : "";
  }

  return (
    <Field.Root
      // required={isRequired}
      invalid={!!error?.message}
      colorPalette={"blue"}
    >
      {label && (
        <Field.Label>
          {label}{" "}
          {isRequired && (
            <Box as="span" color={"red.600"}>
              *
            </Box>
          )}
        </Field.Label>
      )}
      <Input
        bg={"white"}
        type={type}
        {...register(name)}
        value={watchedValue || ""} // Use watched value to ensure re-render
        placeholder={placeholder || label}
        {...props}
      />
      {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
    </Field.Root>
  );
}

export default InputField;
